export default ({ className = '' }) => {
  return <i className={`ph ph-circle-notch spin ${className}`} />
}
